// component
import Page from "@/components/Page";
import Switches from "@/components/Switches";
import Btn from "@/components/Btn";
import Pic from "@/components/Pic";
import Tag from "@/components/Tag";
import Im from "@/components/Im";
import Collect from "@/components/Collect";
import TextareaAutosize from "@/components/TextareaAutosize";
import TipToast from "@/components/TipToast";
import ActionSheet from "@/components/ActionSheet/ActionSheet";
import Avatar from "@/components/Avatar";
import AvatarMessage from "@/components/AvatarMessage";
import AvatarCard from "@/components/AvatarCard";
import AvatarStack from "@/components/AvatarStack";
import AvatarBusinessCard from "@/components/AvatarBusinessCard";
import AlbumDoor from "@/components/AlbumDoor";
import PlanSale from "@/components/PlanSale";
import PlanSalePreview from "@/components/PlanSalePreview";
import AlbumDir from "@/components/AlbumDir";
import AlbumIntro from "@/components/AlbumIntro";
import AlbumIntroEdit from "@/components/AlbumIntroEdit";
import Dir from "@/components/Dir";
import Icon from "@/components/Icon";
import IconCollect from "@/components/IconCollect";
import IconPay from "@/components/IconPay";
import IconPayGroup from "@/components/IconPayGroup";
import NavHeaderPC from "@/components/NavHeaderPC";
import NavHeaderArticleEditPC from "@/components/NavHeaderArticleEditPC";
import NavHeaderMobile from "@/components/NavHeaderMobile";
import NavTabItem from "@/components/NavTabItem";
import NavTabItemGroup from "@/components/NavTabItemGroup";
import NavTabMobile from "@/components/NavTabMobile";
import NavStackMobile from "@/components/NavStackMobile";
import NavMenuMobile from "@/components/NavMenuMobile";
import NavMenuClient from "@/components/NavMenuClient";
import PlanEdit from "@/components/PlanEdit";
import Plan from "@/components/Plan";
import Vote from "@/components/Vote";
import Order from "@/components/Order";
import Like from "@/components/Like";
import Feed from "@/components/Feed";
import FeedAction from "@/components/FeedAction";
import FeedAddBtn from "@/components/FeedAddBtn";
import FeedTiming from "@/components/FeedTiming";
import FeedSmall from "@/components/FeedSmall";
import PreBox from "@/components/PreBox";
import ArticleBox from "@/components/ArticleBox";
import OrderWithdraw from "@/components/OrderWithdraw";
import Step from "@/components/Step";
import Share from "@/components/Share";
import CategorySelect from "@/components/CategorySelect";
import Comment from "@/components/Comment";
import Goal from "@/components/Goal";
import GoalGroup from "@/components/GoalGroup";
import GoalEdit from "@/components/GoalEdit";
import SwiperLazyLoad from "@/components/SwiperLazyLoad";
import Todo from "@/components/Todo";
import DownloadList from "@/components/DownloadList";
import RadioIcon from "@/components/RadioIcon";
import Guide from "@/components/Guide";
import MoreAction from "@/components/MoreAction";
import Banner from "@/components/Banner";
import GroupCard from "@/components/GroupCard";
import RankTop from "@/components/RankTop";
import AuthDoor from "@/components/AuthDoor";
import BlackList from "@/components/BlackList";
import Dropdown from "@/components/Dropdown";
import DashboardHeader from "@/components/DashboardHeader";
import WechatOpenApp from "@/components/WechatOpenApp";

import SponsorInOut from "@/components/SponsorInOut";
import FooterCustom from "@/components/FooterCustom";
import LoginMobile from "@/components/LoginMobile";
import GroupShareCard from "@/components/GroupShareCard";
import SearchBar from "@/components/SearchBar";

import BlockFeed from "@/components/BlockFeed";
import BlockCreator from "@/components/BlockCreator";
import BlockPlan from "@/components/BlockPlan";
import BlockGoal from "@/components/BlockGoal";
import BlockPayment from "@/components/BlockPayment";
import BlockDiscount from "@/components/BlockDiscount";
import BlockGroup from "@/components/BlockGroup";
import BlockAlbum from "@/components/BlockAlbum";
import BlockDoor from "@/components/BlockDoor";
import BlockShop from "@/components/BlockShop";

import Multiselect from "vue-multiselect";
import CheckboxRadio from "vue-checkbox-radio";

import Notifications from "vue-notification";
import VModal from "vue-js-modal/dist/ssr.index";


// async component
const VueCoreImageUpload = () => ({
    component: import("vue-core-image-upload"),
});
// const VueUploadComponent = () => ({
//     component: import("vue-upload-component"),
// });
const Upload = () => ({ component: import("@/components/Upload") });
const UploadCloudFile = () => ({
    component: import("@/components/UploadCloudFile"),
});
const Qa = () => ({ component: import("@/components/Qa") });


// method
import Cookies from "js-cookie";
import VueClipboard from "vue-clipboard2";
import bus from "@/plugin/bus";
import canvas2image from "@/plugin/canvas2image";
import * as $http from "@/api/fetch";
import * as Tool from "@/plugin/tool";
import Meta from "vue-meta";

//directive
// import vClickOutside from 'v-click-outside'
// import ClickOutside from "@/plugin/click-outside";
// import ClickOutside from 'vue-click-outside'
import * as vClickOutside from 'v-click-outside-x';
import Nocopy from "@/plugin/nocopy";
import infiniteScroll from "vue-infinite-scroll";
import VTooltip from 'v-tooltip'
import { VueHammer } from 'vue2-hammer'

//filter

//mixin
import Mixin from "@/plugin/mixin";

//swiper
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

//const
import ENV from "@/plugin/env";
import bridge from "@/plugin/jsbridge";


export function register(Vue) {
    Vue.component("page", Page);
    Vue.component("switches", Switches); // https://github.com/drewjbartlett/vue-switches
    Vue.component("btn", Btn);
    Vue.component("pic", Pic);
    Vue.component("tag", Tag);
    Vue.component("dir", Dir);
    Vue.component("Im", Im);
    Vue.component("vote", Vote);
    Vue.component("wechat-open-app", WechatOpenApp);
    Vue.component("collect", Collect);
    Vue.component("avatar", Avatar);
    Vue.component("avatar-message", AvatarMessage);
    Vue.component("avatar-card", AvatarCard);
    Vue.component("avatar-stack", AvatarStack);
    // Vue.component("avatar-welcome-card", AvatarWelcomeCard);
    Vue.component("avatar-business-card", AvatarBusinessCard);
    Vue.component("icon", Icon);
    Vue.component("icon-collect", IconCollect);
    Vue.component("guide", Guide);
    Vue.component("icon-pay", IconPay);
    Vue.component("icon-pay-group", IconPayGroup);
    Vue.component("nav-header-pc", NavHeaderPC);
    Vue.component("nav-header-article-edit-pc", NavHeaderArticleEditPC);
    Vue.component("nav-header-mobile", NavHeaderMobile);
    Vue.component("nav-tab-item", NavTabItem);
    Vue.component("nav-tab-item-group", NavTabItemGroup);
    Vue.component("plan-edit", PlanEdit);
    Vue.component("plan", Plan);
    Vue.component("order", Order);
    Vue.component("sponsor-in-out", SponsorInOut);
    Vue.component("order-withdraw", OrderWithdraw);
    Vue.component("login-mobile", LoginMobile);
    Vue.component("step", Step);
    Vue.component("share", Share);
    Vue.component("radio-icon", RadioIcon);
    Vue.component("like", Like);
    Vue.component("feed", Feed);
    Vue.component("feed-action", FeedAction);
    Vue.component("feed-add-btn", FeedAddBtn);
    Vue.component("feed-timing", FeedTiming);
    Vue.component("feed-small", FeedSmall);
    Vue.component("pre-box", PreBox);
    Vue.component("article-box", ArticleBox);
    Vue.component("comment", Comment);
    Vue.component("rank-top", RankTop);
    Vue.component("download-list", DownloadList);
    Vue.component("category-select", CategorySelect);
    Vue.component("dashboard-header", DashboardHeader);
    Vue.component("black-list", BlackList);
    Vue.component("footer-custom", FooterCustom);
    Vue.component("nav-tab-mobile", NavTabMobile);
    Vue.component("nav-stack-mobile", NavStackMobile);
    Vue.component("nav-menu-mobile", NavMenuMobile);
    Vue.component("nav-menu-client", NavMenuClient);
    Vue.component("block-feed", BlockFeed);
    Vue.component("block-creator", BlockCreator);
    Vue.component("block-plan", BlockPlan);
    Vue.component("block-goal", BlockGoal);
    Vue.component("block-payment", BlockPayment);
    Vue.component("block-discount", BlockDiscount);
    Vue.component("block-group", BlockGroup);
    Vue.component("block-album", BlockAlbum);
    Vue.component("block-door", BlockDoor);
    Vue.component("block-shop", BlockShop);
    Vue.component("tip-toast", TipToast);
    Vue.component("group-card", GroupCard);
    Vue.component("group-share-card", GroupShareCard);
    Vue.component("textarea-autosize", TextareaAutosize);
    Vue.component("goal", Goal);
    Vue.component("goal-group", GoalGroup);
    Vue.component("goal-edit", GoalEdit);
    Vue.component("todo", Todo);
    Vue.component("more-action", MoreAction);
    Vue.component("banner", Banner);
    Vue.component("album-door", AlbumDoor);
    Vue.component("auth-door", AuthDoor);
    Vue.component("plan-sale", PlanSale);
    Vue.component("plan-sale-preview", PlanSalePreview);
    Vue.component("search-bar", SearchBar);
    Vue.component("action-sheet", ActionSheet);
    Vue.component("album-dir", AlbumDir);
    Vue.component("album-intro", AlbumIntro);
    Vue.component("album-intro-edit", AlbumIntroEdit);
    Vue.component("qa", Qa);
    Vue.component("swiper-lazy-load", SwiperLazyLoad);
    Vue.component("dropdown", Dropdown);

    Vue.component("multiselect", Multiselect); // https://github.com/shentao/vue-multiselect

    if (global.window) {
        Vue.component("vue-core-image-upload", VueCoreImageUpload); // https://github.com/Vanthink-UED/vue-core-image-upload
        // Vue.component("file-upload", VueUploadComponent); //https://lian-yue.github.io/vue-upload-component/#/zh-cn/documents
        Vue.component("upload", Upload); //https://pqina.nl/filepond/
        Vue.component("upload-cloud-file", UploadCloudFile); //https://cloud.tencent.com/document/product/436/9067
    }
    Vue.use(Notifications);

    VueHammer.config.press = { time: 1000};
    Vue.use(VueHammer); //https://github.com/bsdfzzzy/vue2-hammer
    Vue.use(VModal, { dialog: true, dynamic: true }); // https://github.com/euvl/vue-js-modal/blob/master/README.md
    Vue.use(infiniteScroll); //https://github.com/ElemeFE/vue-infinite-scroll
    Vue.use(CheckboxRadio); //https://github.com/mariomka/vue-checkbox-radio
    Vue.use(VueClipboard); //https://github.com/Inndy/vue-clipboard2
    Vue.use(VueAwesomeSwiper /* { default global options } */); //https://github.com/surmon-china/vue-awesome-swiper/tree/v3.1.3   demo: https://v1.github.surmon.me/vue-awesome-swiper/
    Vue.use(VTooltip); //https://floating-vue.starpad.dev/legacy/v2/#getting-started
    Vue.use(Meta);
    Vue.prototype.GL = {
        ENV,
        PIC_HOST: "https://pic1.afdiancdn.com",
    };
    Vue.prototype.$http = $http;
    Vue.prototype.$bus = bus;
    Vue.prototype.$cookies = Cookies;
    Vue.prototype.$canvas2image = canvas2image;
    Vue.prototype.$bridge = bridge;
    Object.keys(Tool).forEach((v) => {
        Vue.prototype[`$${v}`] = Tool[v];
    });
    // Vue.use(vClickOutside)
    Vue.use(vClickOutside);
    // Vue.directive("click-outside", ClickOutside);
    Vue.directive("no-copy", Nocopy);

    Vue.mixin(Mixin);
}
